import { render, staticRenderFns } from "./ElementLoading.vue?vue&type=template&id=f64bfd60"
import script from "./ElementLoading.vue?vue&type=script&lang=js"
export * from "./ElementLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f64bfd60')) {
      api.createRecord('f64bfd60', component.options)
    } else {
      api.reload('f64bfd60', component.options)
    }
    module.hot.accept("./ElementLoading.vue?vue&type=template&id=f64bfd60", function () {
      api.rerender('f64bfd60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/loaders/ElementLoading.vue"
export default component.exports